import { render, staticRenderFns } from "./timetableManagement.vue?vue&type=template&id=22b0d0e2&scoped=true&"
import script from "./timetableManagement.vue?vue&type=script&lang=js&"
export * from "./timetableManagement.vue?vue&type=script&lang=js&"
import style0 from "./timetableManagement.vue?vue&type=style&index=0&id=22b0d0e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b0d0e2",
  null
  
)

export default component.exports